import { toast } from "sonner";
import { shortDate, qLabel, SIZE_LABEL } from "./srUtil";

const CAP = { mega: "Mega cap", large: "Large cap", mid: "Mid cap", small: "Small cap", micro: "Micro cap" };

export const StockHeader = ({ d, following, setFollowing }) => {
  const follow = () => {
    const yes = !following;
    setFollowing(yes);
    toast(yes ? `${d.symbol} followed for this session.` : `${d.symbol} removed from followed names.`);
  };
  return (
    <div className="stock row" data-testid="sr-stock-header">
      <div className="logo">{d.symbol.slice(0, 5)}</div>
      <div>
        <h1 data-testid="sr-company-name">{d.company}</h1>
        <div className="muted company" data-testid="sr-company-meta">
          {d.symbol} · {d.sector}{d.industry ? ` · ${d.industry}` : ""} · {CAP[d.cap_bucket] || SIZE_LABEL[d.cap_bucket] || "US equity"}
        </div>
      </div>
      <div className="price mono" data-testid="sr-price">${d.price.toFixed(2)}<small className="muted">Close · {shortDate(d.price_date, true)}</small></div>
      <button aria-pressed={following} onClick={follow} data-testid="sr-follow-btn">{following ? "✓ Following" : "＋ Follow"}</button>
    </div>
  );
};

export const SrFooter = ({ f }) => (
  <footer data-testid="sr-footer">
    <div className="footerrow"><span className="brand" style={{ fontSize: 16 }}>fundprints<em>•</em></span>
      <span>Evidence, not advice.</span>
      <span>Live data</span></div>
    <p>Prices through {shortDate(f.prices_through, true)} · fund holdings for {qLabel(f.holdings_quarter)} · updated{" "}
      {f.v3_computed_at ? shortDate(f.v3_computed_at.slice(0, 10), true) : "—"} · fund track records as of {shortDate(f.skill_as_of, true)}.
      Performance is shown against similar-sized stocks in the same sector. Funds report their holdings with a delay, so this doesn’t
      show who owns the stock today.</p>
  </footer>
);
